import { render, staticRenderFns } from "./OOSPopUp.vue?vue&type=template&id=26212df2&scoped=true&"
import script from "./OOSPopUp.vue?vue&type=script&lang=js&"
export * from "./OOSPopUp.vue?vue&type=script&lang=js&"
import style0 from "./OOSPopUp.vue?vue&type=style&index=0&id=26212df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26212df2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26212df2')) {
      api.createRecord('26212df2', component.options)
    } else {
      api.reload('26212df2', component.options)
    }
    module.hot.accept("./OOSPopUp.vue?vue&type=template&id=26212df2&scoped=true&", function () {
      api.rerender('26212df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/OOSPopUp.vue"
export default component.exports